import ModalBox from "./ModalBox.js";
import { Button, Form, Input, Select, Upload } from "antd";
import React, { useState } from "react";
import { CUSTOM_TYPES } from "../authentication/Signup.js";
import FloatLabelInput from "./FloatLabelInput.js";
import { CheckCircleOutlined, UploadOutlined } from "@ant-design/icons";
import {
  calcInputSize,
  openNotificationInToast,
} from "../../utilities/index.js";
import { uploadCustomFileSignUpService } from "../../services/apiServices.js";
import Api from "../../services/api.js";
import { COMMONS_SERVICE_BASE_URL } from "../../services/environments.js";

const FormItem = Form.Item;
const { Option } = Select;

function CustomFieldsModalBox({
  open,
  setOpen,
  customFields,
  webinarRegister,
  orgId,
  setCustomFieldsCaptured,
}) {
  const [selectedData, setSelectedData] = useState({});
  const [formsData, setFormsData] = useState({});
  const [focused, setFocused] = useState({ field: "", isFocused: false });

  const onChange = (value, name) => {
    setFormsData({ ...formsData, [name]: value });
  };

  const onChangeOfSelectedData = (selected, key) => {
    setSelectedData({ ...selectedData, [key]: selected });
  };

  const onFocus = (name) => {
    setFocused({ field: name, isFocused: true });
  };

  const onBlur = () => {
    setFocused({ field: "", isFocused: false });
  };

  const onChangeOfImageData = (file, key) => {
    const formData = new FormData();
    formData.append("file", file);
    uploadCustomFileSignUpService(formData)
      .then((response) => {
        onChange(response.imageLink, key);
      })
      .catch((error) => {
        console.log(error);
      });
    return false;
  };

  const validateForm = () => {
    let customFieldCheck = false;
    customFields.forEach((field) => {
      if (field.signupField.fieldType === CUSTOM_TYPES.DROPDOWN) {
        if (
          field.isMandatory &&
          (!selectedData[field.id] || selectedData[field.id].length === 0)
        ) {
          customFieldCheck = true;
        }
      } else {
        if (field.isMandatory && !formsData[field.id]) {
          customFieldCheck = true;
        }
      }
    });
    return customFieldCheck;
  };

  const submitAndRegister = () => {
    let customFieldsData = {};
    customFields.forEach((field) => {
      if (field.signupField.fieldType === CUSTOM_TYPES.DROPDOWN) {
        if (selectedData[field.id]) {
          customFieldsData[field.id] = field.isMultiselect
            ? selectedData[field.id].join(",")
            : selectedData[field.id];
        }
      } else {
        if (formsData[field.id]) {
          customFieldsData[field.id] = formsData[field.id];
        }
      }
    });
    let payload = {
      customFieldsMap: customFieldsData,
      organizationId: orgId,
    };
    Api.post("auth/captureCustomFieldsData", payload, COMMONS_SERVICE_BASE_URL)
      .then((response) => {
        setCustomFieldsCaptured(true);
        webinarRegister();
        setOpen(false);
      })
      .catch((error) => {
        openNotificationInToast(
          "error",
          "Failed!",
          "Failed to updated the data!"
        );
      });
  };

  return (
    <ModalBox
      title="Mandatory Details"
      visible={open}
      setVisible={setOpen}
      className="changeModal"
    >
      <div>
        <div>Please enter the details below before registering the user.</div>
        {customFields && (
          <div id="signup_form" className={" mt-16"}>
            {customFields.map((item) => {
              return item.signupField.fieldType !==
                CUSTOM_TYPES.CONTENT_UPLOAD ? (
                <FloatLabelInput
                  label={
                    item.signupField.fieldName + (item.isMandatory ? " *" : "")
                  }
                  name={item.id}
                  value={
                    item.signupField.fieldType === CUSTOM_TYPES.DROPDOWN ||
                    item.signupField.fieldType === CUSTOM_TYPES.CONTENT_UPLOAD
                      ? selectedData[item.id]
                      : formsData[item.id]
                  }
                >
                  {item.signupField.fieldType === CUSTOM_TYPES.DROPDOWN ? (
                    <FormItem validateStatus={"success"}>
                      <div
                        className={`select_prefix ${
                          focused.isFocused && focused.field === item.id
                            ? "focused"
                            : null
                        }`}
                      >
                        <div className="prefix">
                          <CheckCircleOutlined />
                        </div>
                        <Select
                          size={calcInputSize}
                          showSearch
                          optionFilterProp="children"
                          allowClear
                          mode={item.isMultiselect ? "multiple" : "single"}
                          autoComplete="none"
                          value={selectedData[item.id]}
                          onChange={(value) =>
                            onChangeOfSelectedData(value, item.id)
                          }
                          onFocus={() => onFocus(item.id)}
                          onBlur={onBlur}
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          virtual={false}
                        >
                          {item.signupField.signupFieldOptions &&
                            item.signupField.signupFieldOptions.map(
                              (option) => (
                                <Option
                                  key={item.id + "CUST" + option.id}
                                  value={option.id}
                                >
                                  {option.optionText}
                                </Option>
                              )
                            )}
                        </Select>
                      </div>
                    </FormItem>
                  ) : (
                    <FormItem
                      validateStatus={"success"}
                      style={{ marginTop: 15 }}
                    >
                      <Input
                        value={formsData[item.id]}
                        onChange={(e) => onChange(e.target.value, item.id)}
                        size={calcInputSize}
                        type="text"
                        validateStatus="error"
                        allowClear
                        autoComplete="none"
                        prefix={
                          <div className="prefix">
                            <CheckCircleOutlined />
                          </div>
                        }
                      />
                    </FormItem>
                  )}
                </FloatLabelInput>
              ) : (
                <FormItem>
                  <Upload
                    accept="image/*,.pdf"
                    beforeUpload={(e) => onChangeOfImageData(e, item.id)}
                    maxCount={1}
                  >
                    <Button size="large" icon={<UploadOutlined />}>
                      {item.signupField.fieldName +
                        (item.isMandatory ? " *" : "")}
                    </Button>
                  </Upload>
                </FormItem>
              );
            })}
          </div>
        )}
        <div className="changeModal_buttons">
          <Button onClick={() => setOpen(false)} className="button_default">
            Close
          </Button>
          <Button
            onClick={() => submitAndRegister()}
            disabled={validateForm()}
            type="primary"
          >
            Submit
          </Button>
        </div>
      </div>
    </ModalBox>
  );
}

export default CustomFieldsModalBox;
